const EVENT_NAME_PLACEHOLDER = /\{\{EVENT_NAME\}\}/g

const replaceEventNamePlaceholder = (text: string, eventName?: string) => (
  text.replace(EVENT_NAME_PLACEHOLDER, eventName || "your event")
)

export default replaceEventNamePlaceholder
